import { useState, Suspense } from "react";
import { RENTER_STATUS } from "../../../../../types/renter.type";
import GenericTable from "../../../../../common/components/ui/table/GenericTable";
import { useNavigate } from "react-router-dom";
import Loading from "../../../../../common/components/ui/loading/Loading";
import {
  TableFiltersState,
  TableFilters,
} from "../../../../../common/components/ui/table/TableFilters";
import TableFooter from "../../../../../common/components/ui/table/TableFooter";
import { formatDateAndTime } from "../../../../../common/helpers/date.helpers";
import { ICommission } from "../../../../../types/commission.type";
import ModalChangeConsultant from "../../modal/ModalChangeConsultant";

const STATUS_LABELS = {
  [RENTER_STATUS.Ativo]: "Ativo",
  [RENTER_STATUS.Incompleto]: "Incompleto",
  [RENTER_STATUS.PendentePagamento]: "Pendente de pagamento",
  [RENTER_STATUS.ProntoParaAprovacao]: "Pronto para aprovação",
  [RENTER_STATUS.ReservaPaga]: "Reserva paga",
  [RENTER_STATUS.ReservaPendentePagamento]: "Reserva pendente de pagamento",
  [RENTER_STATUS.Finished]: "Finalizado",
  [RENTER_STATUS.Recision]: "Recisão",
  [RENTER_STATUS.Recall]: "Recolhimento",
  [RENTER_STATUS.WaitingRescision]: "Aguardando recisão",
  [RENTER_STATUS.Congelado]: "Congelado",
};

const EMPTY_ACTION = { eventName: "", data: undefined };
type CommissionProps = {
  commission: ICommission[];
  setActualize: (value: boolean) => void;
  actualize: boolean;
};

function Total(props: CommissionProps) {
  const { actualize, setActualize } = props;
  const commission = props.commission;

  const navigate = useNavigate();
  const [page, setPage] = useState<number>(1);
  const [data] = useState({ itemsPerPage: 10, totalItems: 0 });
  const [isLoading] = useState(false);
  const [action, setAction] = useState<{ eventName: string; data?: unknown }>(
    EMPTY_ACTION
  );
  const [filters, setFilters] = useState<TableFiltersState>({
    search: "",
    status: [],
    filterColumn: "",
    orderBy: "-updatedAt",
  });

  const isAction = (eventName: string) => action.eventName === eventName;
  const cleanActionData = () => {
    setActualize(!actualize);
    setAction(EMPTY_ACTION);
  };
  const nameConsultant = commission[0]?.technicalConsultant;
  const actions = [
    {
      label: "Trocar Consultor",
      action: (data: unknown) =>
        setAction({ eventName: "changeConsultant", data: data as ICommission }),
    },
  ];
  const headers = {
    technicalConsultant: "Consultor",
    sdr: "SDR",
    renterName: "Nome",
    licensePlate: "Placa",
    // renterStatus: 'Status',
    dueDate: "Vencimento",
    activationDate: "Ativado em",
    currentContractStartDate: "Contrato",
    typeCommission: "Comissão",
  };
  const handleFilterChange = (newFilters: Partial<TableFiltersState>) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      ...newFilters,
    }));
  };

  return (
    <Suspense fallback={<Loading />}>
      <div className="tabs-border-line-commission">
        <div className="tabs-item-style-commission">
          <TableFilters
            dashboardHeader={nameConsultant}
            placeholder="nome, email, cpf, cnh..."
            statusOptions={STATUS_LABELS}
            newItemLabel="Novo Cliente"
            onSearch={handleFilterChange}
            entity="commission"
            tableData={commission}
          />
          <GenericTable
            headers={headers}
            data={commission}
            actions={actions}
            setFilters={({ orderBy }) => {
              setFilters((prevFilters) => ({
                ...prevFilters,
                orderBy,
              }));
            }}
            renders={
              {
                renterName: (name, commission) => (
                  <a
                    href={`/clientes/${commission.renterId}`}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(`/clientes/${commission.renterId}`);
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {name as string}
                  </a>
                ),
                licensePlate: (licensePlate, comission) => (
                  <a
                    href={`/veiculos/${
                      (comission as ICommission).licensePlate
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(
                        `/veiculos/${(comission as ICommission).licensePlate}`
                      );
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {licensePlate as string}
                  </a>
                ),
                activationDate: formatDateAndTime,
                currentContractStartDate: formatDateAndTime,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
              } as any
            }
            entity="renters"
          />

          {isLoading && <Loading />}

          <TableFooter
            page={page || 1}
            totalItems={data.totalItems || 0}
            itemsPerPage={+(filters.itemsPerPage ?? 10)}
            goToPage={setPage}
          />

          {isAction("changeConsultant") && (
            <ModalChangeConsultant
              commission={action.data as ICommission}
              onClose={cleanActionData}
              setActualize={setActualize}
              actualize={actualize}
            />
          )}
        </div>
      </div>
    </Suspense>
  );
}

export default Total;
